import { connect } from 'react-redux'
import { withProps, compose, lifecycle } from 'recompose'
import withType from 'components/common/hoc/withType'
import { getSkuInformation } from './helpers'
import BOTSkuFindLowerPriceInfo from './BOTSkuFindLowerPriceInfo'
import { setSkuInformation } from './actions'
import * as selectors from './selectors'

const withSkuInformation = withProps(({ skuLowerPrice }) => ({
  skuInformation: getSkuInformation(skuLowerPrice)
}))

const withSaveData = lifecycle({
  componentDidMount() {
    const { skuLowerPrice, setSkuInformation } = this.props

    setSkuInformation(skuLowerPrice)
  }
})

export default compose(
  withType({ type: 'BOTSkuFindLowerPriceInfo' }),
  connect(null, { setSkuInformation }),
  withSaveData,
  withSkuInformation
)(BOTSkuFindLowerPriceInfo)


// selectors
export { selectors }
